import {createAction, props} from "@ngrx/store";
import {AssetModel, FilterKeyValuePairInterface, PaginationInfoInterface} from "../../interfaces";

export const setAssets = createAction("[Asset] Set Assets", props<{assets: Array<AssetModel>}>());

export const setPaginatedAssets = createAction("[Asset] Set Paginated Assets", props<{assets: Array<AssetModel>}>());

export const setAssetsPaginationInfo = createAction(
  "[Asset] Set PaginationInfo",
  props<{paginationInfo: PaginationInfoInterface}>()
);

export const gotoAssetsPage = createAction("[Asset] Goto Page", props<{page: number}>());

export const applyAssetsFilters = createAction("[Asset] Apply Filter", props<{filters: Array<FilterKeyValuePairInterface>}>());

export const resetAssetsFilters = createAction("[Asset] Reset Filters");
